import { isFunction } from 'lodash';
import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

/* eslint no-undef: "error" */
class GoogleClickId extends AbstractDriver
{
    init(config)
    {
        if (this._exists())
        {
            //do nothing
        }
        else
        {
            this._loadScript(config);
        }
    }

    async pageView()
    {
        //do nothing
    }

    async lead()
    {
        //do nothing
    }

    _exists(showErrors = false)
    {
        if (typeof addGclid === 'undefined' || !isFunction(addGclid))
        {
            if (showErrors)
            {
                console.error('Google ClickID is not initialized');
            }

            return false;
        }

        return true;
    }

    _loadScript(config)
    {
        postscribe(document.querySelector('head'), `
            <!-- Google CLICK ID SCRIPT -->
            <input type="hidden" name="gclid" id="gclid">

            <script type="text/javascript">
                function getParam(p) {
                    var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
                    return match && decodeURIComponent(match[1].replace(/\\+/g, ' '));
                }

                function getExpiryRecord(value) {
                    var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

                    var expiryDate = new Date().getTime() + expiryPeriod;
                    return {
                        value: value,
                        expiryDate: expiryDate
                    };
                }

                function addGclid() {
                    var gclidParam = getParam('gclid');

                    var gclidFormFields = ['gclid_field', 'foobar', 'gclid']; // all possible gclid form field ids here
                    var gclidRecord = null;
                    var currGclidFormField;

                    var gclsrcParam = getParam('gclsrc');
                    var isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

                    gclidFormFields.forEach(function (field) {
                        if (document.getElementById(field)) {
                            currGclidFormField = document.getElementById(field);
                        }
                    });

                    if (gclidParam && isGclsrcValid) {
                        gclidRecord = getExpiryRecord(gclidParam);

                        if(localStorage) {
                           localStorage.setItem('gclid', JSON.stringify(gclidRecord));
                        }
                    }

                    var gclid = gclidRecord;

                    if (!gclid && localStorage) {
                       gclid = JSON.parse(localStorage.getItem('gclid'));
                    }

                    var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

                    if (currGclidFormField && isGclidValid) {
                        currGclidFormField.value = gclid.value;
                    }
                }

                window.addEventListener('load', addGclid);

            </script>
            <!-- End Google CLICK ID SCRIPT -->
        `, {
            done: () =>
            {
                this.init(config);
            },

        });

        return true;
    }
}

export default GoogleClickId;
